import React from "react";
import Page from "../components/Page";

import NavigationData from "../data/nav.remotejson.js";
import FooterNavData from "../data/footerNav.remotejson.js";
import { getWpData } from "../data/general";

import AboutUs from "../views/AboutUs";
import Careers from "../views/Careers";
import Contact from "../views/Contact";
import Documentary from "../views/Documentary";
import Donate from "../views/Donate";
import Events from "../views/Events";
import EventsAlt from "../views/EventsAlt.js";
import Faqs from "../views/Faqs";
import Financials from "../views/Financials";
import GetInvolved from "../views/GetInvolved";
import OurImpact from "../views/OurImpact";
import Partners from "../views/Partners";
import Scholarships from "../views/Scholarships";
import Club from "../views/Club.js";
import FilmFestival from "../views/FilmFestival.js";
import CommunityChoiceVoting from "../views/CommunityChoiceVoting.js";
import TheServiceContinues from "../views/TheServiceContinues.js";

const getTemplate = (templateUri) => {
  const templates = {
    "page-templates/about-us.php": AboutUs,
    "page-templates/careers.php": Careers,
    "page-templates/contact.php": Contact,
    "page-templates/documentary.php": Documentary,
    "page-templates/donate.php": Donate,
    "page-templates/events.php": Events,
    "page-templates/events-alt.php": EventsAlt,
    "page-templates/faqs.php": Faqs,
    "page-templates/film-festival.php": FilmFestival,
    "page-templates/single.php": Financials,
    "page-templates/get-involved.php": GetInvolved,
    "page-templates/our-impact.php": OurImpact,
    "page-templates/partners.php": Partners,
    "page-templates/scholarships.php": Scholarships,
    "page-templates/club.php": Club,
    "page-templates/community-choice-voting.php": CommunityChoiceVoting,
    "page-templates/the-service-continues.php": TheServiceContinues,
  };

  return templates[templateUri];
};

export default function Slug(props) {
  const Template = getTemplate(props.wp.template);

  console.log(Template);

  return Template ? <Template {...props} /> : <Page {...props}></Page>;
}

export async function getStaticProps({ params }) {
  console.log(params.slug, "\n");
  // These pages don't seem to have any ACF fields.
  // The only fields necessary from the design are title (provided by WP) and bg image.
  const page = {
    acf: {
      hero: {
        title: "Alyssa's Story" || fullArticle.title.rendered,
        body: "By: Firstname Lastname" || fullArticle.title.rendered,
        bgImage: "https://placekitten.com/1920/1080",
      },
    },
    params,
  };

  const wpData = {
    ...(await getWpData("pages", params.slug)),
  };

  return {
    props: {
      page,
      ...wpData,
    },
  };
}

export async function getStaticPaths() {
  let blacklistedSlugs = new Set([
    "news",
    "stories",
    "merch",
    "media",
    "press",
    "leadership",
    "terms-of-use",
    "privacy-policy",
    "galleries",
  ]);
  // Collect the paths that tell Next.js to generate pages at these URLs
  let MenuData = [...NavigationData.items, ...FooterNavData.items];

  const extractSlugs = (item) => {
    let slugs = [];

    // Add current item's slug if it exists and isn't blacklisted
    if (item.slug && !blacklistedSlugs.has(item.slug)) {
      slugs.push({ params: { slug: item.slug } });
    }

    // Recursively process child_items
    if (item.child_items && item.child_items.length > 0) {
      item.child_items.forEach((child) => {
        slugs.push(...extractSlugs(child));
      });
    }

    return slugs;
  };

  const paths = MenuData.reduce((acc, item) => {
    return [...acc, ...extractSlugs(item)];
  }, []);

  // Add any WordPress pages that aren't already in the nav/footer
  const wpResponse = await fetch(
    "https://quell.staging.themoderati.com/wp-json/wp/v2/pages?per_page=100",
  );
  const wpPages = await wpResponse.json();

  // Add pages that aren't already in nav/footer
  wpPages.forEach((page) => {
    if (
      page.slug &&
      !blacklistedSlugs.has(page.slug) &&
      !paths.some((path) => path.params.slug === page.slug)
    ) {
      paths.push({
        params: {
          slug: page.slug,
        },
      });
    }
  });
  return {
    paths,
    fallback: false,
  };
}
